/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const BoxLogo = (props: SVGProps) => (
    <AccessibleSVG width={461} height={244} viewBox="0 0 461 244" {...props}>
        <path
            d="M17.142.304c9.379 0 17.001 7.482 17.171 16.828v72.33c14.39-10.786 32.224-17.171 51.528-17.171 32.876 0 61.451 18.479 75.853 45.611 14.398-27.132 42.987-45.611 75.84-45.611 47.399 0 85.85 38.427 85.85 85.839 0 47.434-38.451 85.87-85.85 85.87-32.853 0-61.442-18.496-75.84-45.602C147.292 225.504 118.717 244 85.841 244 38.884 244 .775 206.327.019 159.561H0V17.132C.215 7.786 7.763.304 17.142.304zm409.635 79.753c6.318-7.341 17.773-8.792 25.938-3.132 8.155 5.613 9.848 16.176 3.942 23.742l-46.723 57.351 46.666 57.24c5.918 7.587 4.217 18.12-3.939 23.755-8.164 5.637-19.617 4.202-25.941-3.15l-40.139-49.196-40.162 49.196c-6.252 7.352-17.779 8.787-25.919 3.15-8.14-5.635-9.841-16.168-3.905-23.755h-.016l46.638-57.24-46.638-57.351h.016c-5.936-7.566-4.235-18.124 3.905-23.742 8.14-5.66 19.667-4.209 25.919 3.132v-.012l40.162 49.264 40.196-49.264zm-189.243 26.605c-28.45 0-51.518 23.042-51.518 51.468 0 28.45 23.068 51.497 51.518 51.497 28.438 0 51.494-23.047 51.494-51.497 0-28.426-23.056-51.468-51.494-51.468zm-151.693 0c-28.444 0-51.528 23.042-51.528 51.479 0 28.445 23.084 51.486 51.528 51.486 28.441 0 51.477-23.047 51.477-51.497 0-28.426-23.036-51.468-51.477-51.468z"
            fill={vars.bdlBoxBlue}
            fillRule="evenodd"
        />
    </AccessibleSVG>
);

export default BoxLogo;
